
import Vue from "vue";
import CrmHistory from "@/models/crm/crm-history";
import AppCrmMessageEvent from "./events/CrmMessageEvent.vue";
import AppCrmEmailEvent from "./events/CrmEmailEvent.vue";
import AppCrmCallEvent from "./events/CrmCallEvent.vue";
import AppCrmSaleEvent from "./events/CrmSaleEvent.vue";
import AppCrmAppointmentEvent from "./events/CrmAppointmentEvent.vue";
import AppCrmCloseEvent from "./events/CrmCloseEvent.vue";
import AppCrmFileEvent from "./events/CrmFileEvent.vue";
import {CrmService} from "@/services";
import {CrmEditState} from "@/utils/crm/crm-edit-state";

export default Vue.extend({
	data() {
		return {
			showPinButton: false,
			showButtonBar: false
		};
	},
	props: {
		event: {
			required: true,
			type: Object as () => CrmHistory
		},
		state: {
			required: true,
			type: Object as () => CrmEditState
		}
	},
	methods: {
		pin(){
			this.event.Pinned = !this.event.Pinned;
			CrmService.putCrmHistory([this.event]);
		},
		async remove(){
			let confirm = await this.$wf.confirm(this.$ct("cofirm-delete-event"), this.$t("common.yes"), this.$t("common.no"), this.$ct("common.warning"), "warning");
			if (!confirm) return;
			await CrmService.deleteCrmHistory(this.event.ID);
			this.state.deleteHistoryEvent(this.event);
		},
		async onFileEventEmptied(){
			await CrmService.deleteCrmHistory(this.event.ID);
			this.state.deleteHistoryEvent(this.event);
		},
		async edit(){
			this.$emit("edit",this.event);
		}
	},
	components: {
		AppCrmCallEvent,
		AppCrmAppointmentEvent,
		AppCrmMessageEvent,
		AppCrmCloseEvent,
		AppCrmEmailEvent,
		AppCrmSaleEvent,
		AppCrmFileEvent
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
